import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import type { CampaignOutfit, MixedSelectDropdownItem } from 'types';

import './campaign-outfits-header.scss';

applyTranslations(require('./campaign-outfits-header.i18n.json'));

type Props = {
  campaignOutfitsItems: Array<CampaignOutfit>,
  onAddOutfits: (creatorIds: Array<number>) => void
};


function getCreatorList(campaignOutfitsItems: Array<CampaignOutfit>): Array<MixedSelectDropdownItem> {
  const creatorIds = new Set();
  const creators: Array<MixedSelectDropdownItem> = [];

  campaignOutfitsItems.forEach(item => {
    if (!creatorIds.has(item.creatorProfile.id)) {
      creators.push({
        id: item.creatorProfile.id,
        identifier: String(item.creatorProfile.id),
        value: String(item.creatorProfile.id),
        label: `${item.creatorProfile.influencerFirstName} ${item.creatorProfile.influencerLastName}`,
        isDisabled: false,
        isFocused: false,
        isSelected: false
      });
      creatorIds.add(item.creatorProfile.id);
    }
  });
  return creators;
}

const CampaignOutfitsHeader = ({
  campaignOutfitsItems,
  onAddOutfits
}: Props) => {
  const [creators, setCreators] = React.useState<Array<MixedSelectDropdownItem>>([]);

  React.useEffect(() => {
    const creatorsList = getCreatorList(campaignOutfitsItems);

    setCreators(creatorsList);
  }, [campaignOutfitsItems]);

  const handleItemsToggle = (updatedCreators) => {
    setCreators(updatedCreators);
  };

  const handleClick = () => {
    const selectedCreators = creators.filter((creator) => creator.isSelected);
    const creatorIds = selectedCreators.map((creator) => Number(creator.id));

    onAddOutfits(creatorIds);
  };

  const isDisabled = !creators.filter((creator) => creator.isSelected).length;

  return (
    <div className="campaign-outfits__header">
      {__t('campaign_outfits_header.subtitle')}
      <div className="campaign-outfits__add-outfit">
        <MixedSelectDropdown
          name="msd-with-checkboxes-items"
          items={creators}
          withMulti
          withCheckboxes
          hideSelectedItems
          isDisabled={false}
          className="campaign-outfits__add-outfit-dropdown"
          placeholder={__t('campaign_outfits_header.select_creator_placeholder')}
          onItemsToggle={handleItemsToggle}
        />
        <ActionButton
          color="secondary"
          className="campaign-outfits__button"
          onClick={handleClick}
          disabled={isDisabled}
        >
          {__t('campaign_outfits_header.add_button')}
        </ActionButton>
      </div>
    </div>
  );
};

export default CampaignOutfitsHeader;
